export default "{\n    \"label\": \"Línea de tiempo de servicio esperada\"\n}\n"